import { gql } from '@moonpig/web-core-graphql'
import { PRODUCT_FIELDS_FRAGMENT } from './productFields'

const ADDONS_FIELDS_FRAGMENT = gql`
  fragment AddonsFields on Addon {
    title
    description
    sku
    inStock
    price {
      display
      centAmount
      currencyCode
    }
    image {
      url
    }
  }
`

export const GetProductDetailsGQL = gql`
  ${PRODUCT_FIELDS_FRAGMENT}
  ${ADDONS_FIELDS_FRAGMENT}

  fragment ProductDetailsfields on Product {
    ...ProductFields
    description
  }

  query GetProductDetails(
    $productId: String!
    $variants: [Int]
    $experimentValues: String!
    $algorithmId: String!
  ) {
    productLookup(
      productIds: [$productId]
      filters: { variants: $variants, hasCollageMaker: true }
      experimentValues: $experimentValues
    ) {
      products {
        ...ProductDetailsfields
        frequentlyBoughtTogether: recommendations {
          products {
            ...ProductDetailsfields
          }
        }
        masterVariant {
          productImages {
            images {
              thumb {
                jpgUrl
              }
              small {
                jpgUrl
              }
              medium {
                jpgUrl
              }
              large {
                jpgUrl
              }
              extraLarge {
                jpgUrl
              }
              original {
                jpgUrl
              }
            }
          }
        }
        variants {
          addons(clientUsesDescription: true) {
            ...AddonsFields
          }
          capabilities {
            video
          }
          locations {
            city
            postcode
          }
          content {
            ... on ProductVariantContent {
              modules {
                ... on ProductVariantContentModuleDetails {
                  items {
                    title
                    key
                    value
                  }
                }
              }
            }
            ... on ProductVariantContentNotFoundError {
              message
            }
          }
        }
        peopleAlsoViewed: recommendations(algorithmId: $algorithmId) {
          products {
            ...ProductDetailsfields
          }
        }
        relatedTerms {
          terms
        }
      }
    }
  }
`
